import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '../injection-tokens';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private readonly localStorage = inject(LOCAL_STORAGE);

  getItem<T = any>(key: string): T | null {
    const serializedData = this.localStorage?.getItem(key);

    if (!serializedData) {
      return null;
    }

    try {
      const data = JSON.parse(serializedData);
      return data;
    } catch (err) {
      console.warn('There was an issue parsing data from LocalStorage');
      console.error(err);
      return null;
    }
  }

  setItem<T = any>(key: string, value: T): void {
    this.localStorage?.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    this.localStorage?.removeItem(key);
  }
}
